__turbopack_context__.v({
  "error": "errors-module-scss-module__cRaNNq__error",
});
